import { Navigate, Outlet, RouteObject } from '@rocketlane/rocket-router';
import { AccountsUI } from 'components/organisms/accounts/lists/accounts-ui';
import { AccountsSignalBoard } from 'components/pages/accounts/board/accounts-signal-board';
import { AccountDetailPage } from 'components/pages/accounts/detail';
//import { AccountHomePage } from 'components/pages/accounts/detail/account-home';
import { AccountHomePage } from 'components/pages/accounts/detail/account-home';
import { AllSignalsInsideAccount } from 'components/pages/accounts/detail/all-signals';
import { CompanyPageDocument } from 'components/pages/accounts/detail/company-page-document';
import { EmailPageDocument } from 'components/pages/accounts/detail/email-page-document';
import { AccountEmailsPage } from 'components/pages/accounts/detail/emails';
import { MeetingPageDocument } from 'components/pages/accounts/detail/meeting-page-document';
import { AccountMeetingsPage } from 'components/pages/accounts/detail/meetings';
import { AccountTimelinePage } from 'components/pages/accounts/detail/meetings-timeline';
import {
  AccountPeopleBoardPage,
  AccountPeopleListPage,
  AccountPeopleProfilePage,
} from 'components/pages/accounts/detail/people';
import { AccountSignalsV2Page } from 'components/pages/accounts/detail/signals-v2';
import { AccountSpacesPage } from 'components/pages/accounts/detail/spaces';
import { ROUTE_PATHS } from './route-paths';
import { SecureRoute } from './secure-route';

const accountDetailRoutes: RouteObject = {
  path: ROUTE_PATHS.ACCOUNT_DETAIL,
  element: (
    <SecureRoute>
      <AccountDetailPage />
    </SecureRoute>
  ),
  children: [
    {
      index: true,
      element: <AccountHomePage />,
    },
    {
      path: ROUTE_PATHS.ACCOUNT_DETAIL_MEETINGS,
      element: <AccountMeetingsPage />,
    },
    {
      path: ROUTE_PATHS.ACCOUNT_DETAIL_EMAILS,
      element: <AccountEmailsPage />,
    },
    {
      path: ROUTE_PATHS.ACCOUNT_DETAIL_TIMELINE,
      element: <AccountTimelinePage />,
    },
    {
      path: ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE,
      element: <Navigate to={ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_LIST} replace />,
    },
    {
      path: `${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_LIST}`,
      element: <AccountPeopleListPage />,
    },
    {
      path: `${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_BOARD}`,
      element: <AccountPeopleBoardPage />,
    },
    {
      path: `${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_DETAIL}`,
      element: <AccountPeopleProfilePage />,
    },
    {
      path: ROUTE_PATHS.ACCOUNT_DETAIL_SPACES,
      element: <AccountSpacesPage />,
    },
    {
      path: `${ROUTE_PATHS.ACCOUNT_DETAIL_MEETINGS}/${ROUTE_PATHS.ACCOUNT_DOCUMENT}`,
      element: <MeetingPageDocument />,
    },
    {
      path: `${ROUTE_PATHS.ACCOUNT_DETAIL_SPACES}/${ROUTE_PATHS.ACCOUNT_DOCUMENT}`,
      element: <CompanyPageDocument />,
    },
    {
      path: `${ROUTE_PATHS.ACCOUNT_DETAIL_EMAILS}/${ROUTE_PATHS.ACCOUNT_DOCUMENT}`,
      element: <EmailPageDocument />,
    },
    {
      path: ROUTE_PATHS.ALL_SIGNALS,
      element: <AllSignalsInsideAccount />,
    },
    {
      path: ROUTE_PATHS.SIGNALS_V2,
      element: <AccountSignalsV2Page />,
    },
  ],
};

export const accountsRoutes: RouteObject = {
  path: ROUTE_PATHS.ACCOUNTS,
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <AccountsSignalBoard isModuleFederation={false} />,
    },
    {
      path: ROUTE_PATHS.LIST,
      element: <AccountsUI />,
    },
    accountDetailRoutes,
  ],
};
